import React, {useEffect, useState} from 'react';
import {
    Container,
    NavMenuContainer,
    ListNavMenu,
    NavMenuItem,
    NavMenuLink,
    NavBrandContainer,
    DropDownContainer,
    DropDownMenu,
    DropDownMenuLeft,
    DropDownMenuRight,
    MenuBanner,
    MenuBannerButton,
    BrandsContainer,
    BrandLink,
    Header,
    IconWrapper,
    Title,
    BrandsLink,
    ExpressLogo,
    // WrapperBrand
    } from './NavMenu.style'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {computePosition, shift} from '@floating-ui/dom';
import * as Icons from "../../../../../components/AllSvgIcon";
import { TreeMenu } from "../../../../../components/TreeMenu/TreeMenu";
import SubNavMenu from '../SubNavMenu/SubNavMenu';
import API from "../../../../../network/redAPI";
import DropDown from '../../../../../components/DropDown';
import { paddingLeft } from 'styled-system';
import { NewArrivalIcon, PromotionIcon, BestSellerIcon } from '../../../../../assets/icons/BestDeal';
import NewImage from './image/Best seller promotion 3.jpg' 
import delishopExpressIcon from '../../../../../assets/icons/delixpress_logo2.svg';
import { useStoreLogo } from '../../../../../contexts/store-logo/use-storeLogo';
import LazyLoad from 'react-lazyload';
import t from "../../../../../i18n/translate";
const typelocal = localStorage.getItem('type')

const NavBrands = (props) => {
    const handleBrandClick = (brand_ref_id) => {
        window.scrollTo(0,0);
        localStorage.setItem('mode', "brand");
        window.location.href = `/brand/${brand_ref_id}`;
    }
    return (
        <>
        {typeof props.brands !== 'undefined'&& props.brands !== null ? (
            <>
            {/* <WrapperBrand> */}
                <BrandsContainer>
                    {props.brands.slice(0,16).map((brand, key) => {
                        return(
                            <BrandLink key={key} onClick={(e) => handleBrandClick(brand.brand_ref_id)}>
                                {brand.logo !== null ?(
                                    <img src={brand.logo} alt={"logo"} />
                                ):(
                                    <span style={{paddingLeft: '30px'}}></span>
                                )

                                }
                                
                                <div>
                                    <span>{brand.name}</span>
                                </div>
                            </BrandLink>
                        )
                    })}
                </BrandsContainer>
                <div className='d-flex justify-content-center mt-4 mb-2'>
                    <BrandsLink 
                        onClick={(e) => {
                            window.scrollTo(0,0);
                            window.location.href = `/brands`;
                        }}
                    >
                        <h5>See More</h5>
                    </BrandsLink>
                </div>
            {/* </WrapperBrand> */}
            </>
        ):(
            <div>NO catagory</div>
        )}
        </>
    )
}

const NavPartnerPage = (items) => {
    const handleBrandClick = (brand_ref_id) => {
        window.scrollTo(0,0);
        window.location.href = `/partner/${brand_ref_id}`;
    }
    return (
        <>
        {items?.pageList?.length > 0 ? (
            <>
            {/* <WrapperBrand> */}
                <BrandsContainer>
                    {items.pageList.slice(0,16).map((brand, key) => {
                        return(
                            <BrandLink key={key} onClick={(e) => handleBrandClick(brand.slug)}>
                                {brand.logo !== null ?(
                                    <img src={brand.logo} alt={"logo"} />
                                ):(
                                    <span style={{paddingLeft: '30px'}}></span>
                                )

                                }
                                
                                <div>
                                    <span>{brand.title}</span>
                                </div>
                            </BrandLink>
                        )
                    })}
                </BrandsContainer>
                <div className='d-flex justify-content-center mt-4 mb-2'>
                    <BrandsLink 
                        onClick={(e) => {
                            window.scrollTo(0,0);
                            window.location.href = `/partner`;
                        }}
                    >
                        <h5>See More</h5>
                    </BrandsLink>
                </div>
            {/* </WrapperBrand> */}
            </>
        ):(
            <div>No Partners</div>
        )}
        </>
    )
}
const NavMenu = (props) => {
    let mql = window.matchMedia("all and (min-width: 991px)");
    const { storeLogo } = useStoreLogo();

    const [type, setType] = useState([])
    useEffect(() => {
        if(mql.matches){
        // if(typelocal){
        //     setType(JSON.parse(typelocal))
        // }
        // else{
            API.Type()
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                setType(data.data)
                // localStorage.setItem('type', JSON.stringify(data.data))
                } else {
                    alert(data.error)
                }
            });            
        // }
        }

    },[])

    // const handleDropdown = (event) => {
    //     if(!event.target.classList.contains('navBarItem')){
    //         return
    //     }
    //     let referenceEl = event.target
    //     let floatingEl = event.target.querySelector('.item-dropdown')
    //     computePosition(referenceEl, floatingEl, {
    //         middleware: [shift({
    //             crossAxis: true,
    //         })],
    //     }).then(({x,y}) => {
    //         Object.assign(floatingEl.style, {
    //             left: `${x}px`,
    //             top: `${y}px`
    //         })
    //     })
    //     // event.classList.contains('item-dropdown')
    // }

    const [dataToggle,setDataToggle] = useState('');
    const handleDropdown = (event) => {
        let idEl = event.target.dataset.toggle || dataToggle //element Id
        if(idEl){
            setDataToggle(idEl);
        }
        let dropDownCon = document.getElementById("menu-dropdown-container")
        let dropdownEl = document.getElementById(idEl+"-menu")
        if(!idEl){
            dropdownEl = document.getElementById(dataToggle+"-menu")
        }
        if(idEl && dataToggle !== idEl){
            dropdownEl = document.getElementById(idEl+"-menu")
            let old = document.getElementById(dataToggle+"-menu")
            if(old) {
                old.classList.remove("active")
            }
        }
        dropDownCon.classList.add("active")
        if(dropdownEl){
            dropdownEl.classList.add("active")
        }
        
    }

    const handleDropUp = (event) => {
        let idEl = event.target.dataset.toggle //element Id

        let dropdownCon = document.getElementById("menu-dropdown-container")
        let dropdownEl = document.getElementById(idEl+"-menu")
        dropdownCon.classList.remove("active")
        if(dropdownEl){
            dropdownEl.classList.remove("active")
        } 
    }

    const handleBrandsClick = () => {
        window.scrollTo(0,0);
        window.location.href = '/brands';
    }

    // useEffect(() => {
    //     if(window.location.pathname?.split("/")?.includes("notification")){
    //         props.props.getProductBrands()
    //     }
    // },[])
    
    const [pageList,setPageList] = useState([]);
    const [limit,setLimit] = useState(20);
    const [page,setPage] = useState(1);
    useEffect(() => {
        let body = {
            page_type : "partner_page",
            limit : limit,
            page : page
        }
        props.props.getPartnerPages(body)
    },[])
    
    return(
        <>
        {/* <NavMenuContainer>
            <div className='scroll'>
                {type.map((menu, key) => {
                    return (
                        <NavMenuItem onMouseOver={(e) => handleDropdown(e)} className='navBarItem'>
                            <div className='item-button'>
                                <span>{menu.name}</span>
                                <ExpandMoreIcon/>
                            </div>
                            <div className='item-dropdown'>
                                <SubNavMenu
                                    categories={menu.map_categories_types}
                                    props={props}
                                >
                                </SubNavMenu>
                            </div>
                        </NavMenuItem>
                    )})
                }
            </div>
        </NavMenuContainer> */}
        {mql.matches && type.length > 0 &&
            <>
            <Container>
                <NavMenuContainer>
                    <div>
                        <ListNavMenu>
                            <NavMenuItem>
                                <NavMenuLink  href="/express">
                                    <ExpressLogo>
                                        <div className='first'>
                                            <span>GO</span>
                                            <span className='to'>TO</span>
                                        </div>
                                        <div className='second'>
                                          <LazyLoad once>
                                            <img
                                              src={storeLogo?.express ?? delishopExpressIcon}
                                              alt="Delishop Express"
                                              loading="lazy"
                                              height="30"
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src =delishopExpressIcon;
                                              }}
                                              />
                                          </LazyLoad>
                                        </div>
                                        <div className='third'>
                                                
                                        </div>
                                        <div className='fourth'>
                                                
                                        </div>
                                    </ExpressLogo>
                                </NavMenuLink>
                                </NavMenuItem>
                            <NavMenuItem>
                                <NavMenuLink
                                    onMouseEnter={(e) => handleDropdown(e)} 
                                    onMouseLeave={(e) => handleDropUp(e)}
                                    data-toggle={"new"}   
                                >
                                    <span>New</span>  
                                </NavMenuLink>
                            </NavMenuItem>
                            {/* <NavMenuItem className='best-deal'>
                                <NavMenuLink href='/best-deals/new-arrivals'>
                                        <NewArrivalIcon />
                                        <span>New Arrivals</span>
                                </NavMenuLink>
                            </NavMenuItem>  
                            <NavMenuItem className='best-deal'>
                                <NavMenuLink href='/best-deals/promotions'>
                                    <PromotionIcon /> 
                                    <span>Promotions</span>
                                </NavMenuLink>
                            </NavMenuItem>  
                            <NavMenuItem className='best-deal'> 
                                <NavMenuLink href='/best-deals/best-seller'>
                                    <BestSellerIcon /> 
                                    <span>Best Sellers</span>
                                </NavMenuLink>
                            </NavMenuItem>  */}
                            {type.map((menu, key) => {
                                return(
                                    <NavMenuItem key={key}>
                                        <NavMenuLink 
                                            onMouseEnter={(e) => handleDropdown(e)} 
                                            onMouseLeave={(e) => handleDropUp(e)}
                                            data-toggle={menu.type_ref_id}
                                        >
                                            <span>{menu.name}</span>
                                        </NavMenuLink>
                                    </NavMenuItem>                                
                                )
                                })
                            }  
                        </ListNavMenu>
                    </div>
                    <div className='d-flex'>     
                        <NavBrandContainer>
                            <NavMenuLink 
                                onMouseEnter={(e) => handleDropdown(e)} 
                                onMouseLeave={(e) => handleDropUp(e)}
                                // onClick={handleBrandsClick}
                                data-toggle="brand"
                                >
                                <div className='menu-name-container'>
                                    {/* {pageList && pageList && pageList?.length === 0 ? 
                                        <span>Brand</span>
                                        :  */}
                                        <span>{t('partner')}</span>
                                    {/* } */}
                                </div>
                            </NavMenuLink>
                        </NavBrandContainer>  
                    </div>        
                </NavMenuContainer>
            </Container>
                <DropDownContainer id="menu-dropdown-container">
                    <DropDownMenu id={`new-menu`} 
                        onMouseEnter={(e) => handleDropdown(e)} 
                        onMouseLeave={(e) => handleDropUp(e)}
                        data-toggle={"new"}
                    >
                        <DropDownMenuLeft>
                            <img src={NewImage} />
                        </DropDownMenuLeft>
                        <DropDownMenuRight className='row'>
                            <div className='col-9'>
                                <SubNavMenu
                                    categories={'new'}
                                    props={props}
                                >
                                </SubNavMenu>                                  
                            </div>
                                <div className='col-3'>
                                    <MenuBanner>
                                        <MenuBannerButton
                                            onClick={() => {
                                                window.scrollTo(0,0);
                                                window.location.href = '/best-deals/new-arrivals';
                                                
                                            }}
                                            className='new-arrivals'
                                        >
                                            <div>New Arrivals</div>
                                        </MenuBannerButton>
                                        <MenuBannerButton
                                            onClick={() => {
                                                window.scrollTo(0,0);
                                                window.location.href = '/best-deals/promotions';
                                                
                                            }}
                                            className='promotions'
                                        >
                                            <div>Promotions</div>
                                        </MenuBannerButton>
                                        <MenuBannerButton
                                            onClick={() => {
                                                window.scrollTo(0,0);
                                                window.location.href = '/best-deals/best-seller';
                                                
                                            }}
                                            className='best-sellers'
                                        >
                                            <div>Best Sellers</div>
                                        </MenuBannerButton>
                                        {/* <div>
                                            {menu.banner_image !== ""?
                                                <img src={menu.banner_image}/>
                                                :<img src="https://delishop.s3-ap-southeast-1.amazonaws.com/product/1666432597475"/>
                                            }
                                        </div> */}
                                        
                                    </MenuBanner>
                                    
                                </div>

                         </DropDownMenuRight>

                    </DropDownMenu>
                {type.map((menu, key) => {
                    return (
                        <DropDownMenu key={key} id={`${menu.type_ref_id}-menu`}                            
                            onMouseEnter={(e) => handleDropdown(e)} 
                            onMouseLeave={(e) => handleDropUp(e)}
                            data-toggle={menu.type_ref_id}
                        >
                            <DropDownMenuLeft>
                                            {menu.banner_image !== ""?
                                                <img src={menu.banner_image}/>
                                                :<img src="https://delishop.s3-ap-southeast-1.amazonaws.com/product/1666432597475"/>
                                            }
                             </DropDownMenuLeft>
                            <DropDownMenuRight className='row'>
                                <div className='col-9'>
                                    <SubNavMenu
                                        categories={menu.map_categories_types}
                                        props={props}
                                    >
                                    </SubNavMenu>                                    
                                </div>
                                <div className='col-3'>
                                    <MenuBanner>
                                        <MenuBannerButton
                                            onClick={() => {
                                                window.scrollTo(0,0);
                                                window.location.href = '/best-deals/new-arrivals';
                                                
                                            }}
                                            className='new-arrivals'
                                        >
                                            <div>New Arrivals</div>
                                        </MenuBannerButton>
                                        <MenuBannerButton
                                            onClick={() => {
                                                window.scrollTo(0,0);
                                                window.location.href = '/best-deals/promotions';
                                                
                                            }}
                                            className='promotions'
                                        >
                                            <div>Promotions</div>
                                        </MenuBannerButton>
                                        <MenuBannerButton
                                            onClick={() => {
                                                window.scrollTo(0,0);
                                                window.location.href = '/best-deals/best-seller';
                                                
                                            }}
                                            className='best-sellers'
                                        >
                                            <div>Best Sellers</div>
                                        </MenuBannerButton>
                                        {/* <div>
                                            {menu.banner_image !== ""?
                                                <img src={menu.banner_image}/>
                                                :<img src="https://delishop.s3-ap-southeast-1.amazonaws.com/product/1666432597475"/>
                                            }
                                        </div> */}
                                        
                                    </MenuBanner>
                                    
                                </div>
                            </DropDownMenuRight>
                        </DropDownMenu>
                    )
                  })
                }
	                {pageList && pageList && pageList?.length === 0 ?
		                <DropDownMenu id="brand-menu"
                    onMouseEnter={(e) => handleDropdown(e)} 
                    onMouseLeave={(e) => handleDropUp(e)}
                    data-toggle="brand"
                >
                    {/* {props.props.all_pages && props.props.all_pages?.length === 0 ? 
                    <NavBrands brands={props.props.brands}/> : */}
                    <NavPartnerPage pageList={props.props.all_pages}/>
                     {/* } */}
                </DropDownMenu>
		                :
		                <DropDownMenu id="brand-menu"
		                              onMouseEnter={(e) => handleDropdown(e)}
		                              onMouseLeave={(e) => handleDropUp(e)}
		                              data-toggle="brand"
		                >
			                <NavPartnerPage pageList={pageList}/>
		                </DropDownMenu>
	                }
            </DropDownContainer>
            </>
        }
        </>
    )
}

export default NavMenu;